import FinancialIcon from '@material-ui/icons/AttachMoney'
import Financial from './Financial';

export default {
  home: Financial,
  icon: FinancialIcon,
}
